import { render, staticRenderFns } from "./ArtistAsset.vue?vue&type=template&id=43acaf40&scoped=true&"
import script from "./ArtistAsset.vue?vue&type=script&lang=js&"
export * from "./ArtistAsset.vue?vue&type=script&lang=js&"
import style0 from "./ArtistAsset.vue?vue&type=style&index=0&id=43acaf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acaf40",
  null
  
)

export default component.exports